import { TFunction } from 'i18next';
import { coursesToSelectOptions, enumToSelectOptions } from '../../../utils';
import { AddUserInput, CalendarItem, SelectFormOption, UserRole } from '../../../types/Forms';

export const getUserAddInputs = (
  t: TFunction,
  actionId?: number,
  coursesListOptions?: {
    value: string;
    label: string;
  }[],
): AddUserInput[] => {
  const inputsArray: AddUserInput[] = [
    {
      label: t('users.usersList.inputs.labelFirstName'),
      title: t('users.usersList.inputs.titleFirstName'),
      slug: 'firstName',
      placeholder: t('users.usersList.inputs.placeholderFirstName'),
      type: 'text',
    },
    {
      label: t('users.usersList.inputs.labelLastName'),
      title: t('users.usersList.inputs.titleLastName'),
      slug: 'lastName',
      placeholder: t('users.usersList.inputs.placeholderLastName'),
      type: 'text',
    },
    {
      label: 'E-mail',
      title: 'E-mail',
      slug: 'email',
      placeholder: t('users.usersList.inputs.placeholderEmail'),
      type: 'email',
    },

    {
      label: t('users.usersList.inputs.labelTelegram'),
      title: t('users.usersList.inputs.titleTelegram'),
      slug: 'telegram',
      placeholder: t('users.usersList.inputs.placeholderTelegram'),
      type: 'text',
    },
    {
      label: t('users.usersList.inputs.labelPassword'),
      title: t('users.usersList.inputs.titlePassword'),
      slug: 'password',
      placeholder: t('users.usersList.inputs.placeholderPassword'),
      type: 'text',
    },
    {
      label: t('users.usersList.inputs.labelCity'),
      title: t('users.usersList.inputs.titleCity'),
      slug: 'city',
      placeholder: t('users.usersList.inputs.placeholderCity'),
      type: 'text',
    },
    {
      label: t('users.usersList.inputs.labelDOB'),
      title: t('users.usersList.inputs.titleDOB'),
      slug: 'dob',
      placeholder: t('users.usersList.inputs.placeholderDOB'),
      type: CalendarItem.Date,
    },
    {
      label: t('users.usersList.inputs.labelRole'),
      title: t('users.usersList.inputs.titleRole'),
      slug: 'role',
      placeholder: t('users.usersList.inputs.placeholderRole'),
      type: 'select',
      options: enumToSelectOptions(UserRole, 'users.usersList.inputs.roles', t),
    },
    {
      label: t('users.usersList.inputs.labelPhoto'),
      title: t('users.usersList.inputs.titlePhoto'),
      slug: 'photo',
      placeholder: t('users.usersList.inputs.placeholderPhoto'),
      type: 'file',
    },
  ];
  if (coursesListOptions) {
    inputsArray.push({
      label: t('users.usersList.inputs.labelCourse'),
      title: t('users.usersList.inputs.titleCourse'),
      slug: 'coursesOptions',
      placeholder: t('users.usersList.inputs.placeholderCourse'),
      type: 'select',
      options: coursesListOptions,
    });
  }
  if (actionId === 2) {
    // For Edit User form, remove password field
    return inputsArray.filter((input) => input.slug !== 'password');
  }
  return inputsArray;
};
